// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export function loadAdrum() {
  const APPDYNAMICS_APPKEY = import.meta.env.VITE_APPDYNAMICS_APPKEY;
  const APPDYNAMICS_ADRUMEXTURLHTTP = import.meta.env.VITE_APPDYNAMICS_ADRUMEXTURLHTTP;
  const APPDYNAMICS_ADRUMEXTURLHTTPS = import.meta.env.VITE_APPDYNAMICS_ADRUMEXTURLHTTPS;
  const APPDYNAMICS_BEACONURLHTTP = import.meta.env.VITE_APPDYNAMICS_BEACONURLHTTP;
  const APPDYNAMICS_BEACONURLHTTPS = import.meta.env.VITE_APPDYNAMICS_BEACONURLHTTPS;
  const APPDYNAMICS_SRC = import.meta.env.VITE_APPDYNAMICS_SRC;

  const adrumScript = document.createElement("script");

  window["adrum-start-time"] = new Date().getTime();
  (function (config) {
    config.appKey = APPDYNAMICS_APPKEY;
    config.adrumExtUrlHttp = APPDYNAMICS_ADRUMEXTURLHTTP;
    config.adrumExtUrlHttps = APPDYNAMICS_ADRUMEXTURLHTTPS;
    config.beaconUrlHttp = APPDYNAMICS_BEACONURLHTTP;
    config.beaconUrlHttps = APPDYNAMICS_BEACONURLHTTPS;
    config.xd = { enable: true };
    config.spa = { spa2: true };
  })(window["adrum-config"] || (window["adrum-config"] = {}));

  adrumScript.src = APPDYNAMICS_SRC;
  adrumScript.async = true;
  adrumScript.onerror = () => {
    console.log("Error occurred while loading adrum script");
  };
  document.head.appendChild(adrumScript);
}
